module.exports = __webpack_public_path__ + "static/img/reporticon7.2eab2992.png";